exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".plan-box{background-color:#fff;border-radius:5px;width:90%;margin-left:5%;box-shadow:0 2px 2px #efefef}.plan-box div{padding:15px;border-bottom:1px solid #e8e8e8}.plan-box div img{width:100%;height:105%}@media only screen and (max-width:767px){.plan-box div img{width:50%;margin-left:25%}}.plan-box div:first-child{background-color:#fcfcfc;border-top-left-radius:5px;border-top-right-radius:5px;height:200px}.plan-box div:last-child{text-align:center;border:0}.plan-price-meal{font-size:80%}.plan-box p{padding:10px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-7db7f468","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/Companies.vue
// module id = 48
// module chunks = 0